/** @var jQuery */
jQuery(document).ready(function ($) {
    // Bootstrap breakpoints.
    var breakpoints = {
        sm: 576,
        md: 768,
        lg: 992,
        xl: 1240
    };

    
    // Language switcher.
    (function () {
        var switcher_current = $("#language-switcher-current");
        var switcher_menu    = $("#language-switcher-menu");

        switcher_current.on("click", function (event) {
            event.stopPropagation();
            switcher_menu.toggleClass("-active");
        });

        $(document.body).on("click", function () {
            switcher_menu.removeClass("-active");
        });
    })();

    // Contact in header.
    (function () {
        var header_contact_items = $("#header-contact .contact-item");

        header_contact_items.on("click", function (event) {
            event.stopPropagation();

            var item    = $(this);
            var content = item.find(".content");

            if (!content.hasClass("-active")) {
                content.addClass("-active");

                if (window.innerWidth < breakpoints.sm) {
                    event.preventDefault();
                }
            }
        });

        $(document.body).on("click", function () {
            header_contact_items.find(".content").removeClass("-active");
        });
    })();

    // Sticky header.
    (function () {
        var header_main       = $("#header-main");
        var header_bar        = $("#header-bar");
        var scroll_breakpoint = (header_bar.offset().top + header_bar.outerHeight());

        var on_scroll = function() {
            if ($(window).scrollTop() > scroll_breakpoint) {
                header_main.addClass("sticky");
            } else {
                header_main.removeClass("sticky");
            }
        };

        $(window).on("scroll", on_scroll);
        setTimeout(on_scroll, 50);
    })();

    // Main navigation.
    (function () {
        var navigation = $("#main-nav");
        var toggler    = $("#main-nav-toggler");

        toggler.on("click", function () {
            if (navigation.hasClass("-active")) {
                navigation.removeClass("-active");
                toggler.removeClass("-active");
            } else {
                navigation.addClass("-active");
                toggler.addClass("-active");
            }
        });
    })();

    // Search form.
    (function () {
        var search = $("#search-form");

        $("#search-form-toggler").on("click", function () {
            search.toggleClass("-active");
        });
    })();


    // Homepage.
    (function () {
        if (!document.body.classList.contains("home")) {
            return;
        }

        // Slider.
        $("#hero-slider").owlCarousel({
            items: 1,
            loop: false,
            rewind: true,
            autoplay: true,
            autoplayTimeout: 6000,
            autoplayHoverPause: true,
            mouseDrag: false,
            touchDrag: false,
            pullDrag: false,
            freeDrag: false,
            nav: false,
            dots: true,
        });
    })();

    // Homepage.
    (function () {
        if (!document.body.classList.contains("page-template-template-homepage-new")) {
            return;
        }

        // Slider.
        $(".main-slider").owlCarousel({
            items: 1,
            loop: false,
            rewind: true,
            autoplay: true,
            autoplayTimeout: 6000,
            autoplayHoverPause: true,
            mouseDrag: false,
            touchDrag: false,
            pullDrag: false,
            freeDrag: false,
            nav: false,
            dots: true,
        });
    })();
});
